const datetimeFormats = {
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
  long: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  },
};

const numberFormats = {
  currency: {
    style: 'currency',
    currency: 'JPY',
    useGrouping: true,
    currencyDisplay: 'symbol',
  },
  decimal: {
    style: 'decimal',
    minimumSignificantDigits: 3,
    maximumSignificantDigits: 5,
  },
  percent: {
    style: 'percent',
    useGrouping: false,
  },
};

export default {
  datetimeFormats,
  numberFormats,
};
